import {FileWithPath} from 'react-dropzone';
import {array, mixed, number, object, string} from 'yup';

import {GeoFilterOption} from '@entities/common';

export const v8nSchema = object().shape({
  name: string().required(),
  logoFile: mixed<FileWithPath>().nullable().defined(),
  appUrl: string().defined(),
  webUrl: string().defined(),
  activeFrom: mixed<Date>().nullable().defined(),
  activeTo: mixed<Date>().nullable().defined(),
  geos: array().of(mixed<GeoFilterOption>().required()).defined(),
  order: number().integer().min(0).defined(),
});

export interface FormValues {
  name: string;
  logoFile: FileWithPath | null;
  appUrl: string;
  webUrl: string;
  activeFrom: Date | null;
  activeTo: Date | null;
  geos: GeoFilterOption[];
  order: number;
}
